module.exports = __webpack_public_path__ + "static/media/hotelPlayas.c38d454f.webp";